export enum ChargerModelEnum {
  ChargerOura3 = 'charger-oura-3',
  ChargerOura4 = 'charger-oura-4',
  ChargerSet = 'charger-set',
}
